module.exports = __webpack_public_path__ + "static/media/show-order-online.2f87bd80.png";